import { type RouteObject } from 'react-router';

import { ErrorPage } from '@@containers/App/ErrorPage';

export const metadataRoute: RouteObject = {
    path: 'metadata',
    lazy: async () => {
        const { default: MetadataForm } = await import('@@containers/metadata/MetadataForm');

        return { Component: MetadataForm };
    },
    errorElement: <ErrorPage />,
};

export const pushRoute: RouteObject = {
    path: 'push',
    lazy: async () => {
        const { default: PushMessages } =
            await import('@@containers/metadata/components/Push/PushMessages');

        return { Component: PushMessages };
    },
    errorElement: <ErrorPage />,
};
